import React from 'react';
import Skeleton from 'react-loading-skeleton';

const UsersSkeleton = () => {
  const styles = {
    top: {
      marginTop: 30,
    },
  };
  return (
    <div
      style={{ width: '100%' }}
    >
      <Skeleton count={1} height={300} borderRadius={15} style={styles.top} />
    </div>

  );
};

export default UsersSkeleton;
